<template>
  <div>
    <div class="row mb-md-4 mb-2 mt-md-4 mt-0 align-items-center" v-if="!qrCodeImage">
      <div class="col">
        <h1 class="mb-0 text-md-start text-center">{{ trans('order_checkout') }}</h1>
      </div>
    </div>

    <div v-if="orderNotFound" >
      <div class="alert alert-danger">
        {{ trans('order_not_found') }}
      </div>
    </div>

    <div v-if="order && !confirmingEmail && !qrCodeImage"
         class="checkout-form">

      <PayMethods v-model="form.pay_system"
                  class="mb-md-4 mb-3"/>

      <div class="bigger-text">{{ trans('enter_your_contact_details') }}:</div>

      <div class="form-group">
        <label class="label-ch d-md-block d-none" for="email-ch">Email:</label>
        <div class="row align-items-center">
          <div class="col-md-7 col-12">
            <input type="email"
                   id="email-ch"
                   placeholder="Email"
                   class="form-control"
                   v-model="form.email"/>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="label-ch d-md-block d-none" for="phone-ch">{{ trans('phone') }}:</label>
        <div class="row align-items-center">
          <div class="col-md-7 col-12">
            <vue-tel-input v-if="newPhoneInputEnabled"
                           ref="phoneTelInput"
                           v-model="form.phone"
                           mode="international"
                           default-country="kz"
                           :auto-default-country="false"
                           :preferred-countries="['kz', 'ru']"
                           :all-countries="phoneCountries"
                           :input-options="phoneInputOptions"
                           :dropdown-options="phoneDropdownOptions"
                           invalid-msg="Неверный номер телефона"
                           valid-characters-only
                           styleClasses="form-control phone-tel-input"
                           @open="onPhoneDropdownOpen"/>
            <input v-else
                   type="text"
                   @input="restrictPhoneInput"
                   id="phone-ch"
                   :placeholder="trans('phone')+' (+7XXXXXXXXXX)'"
                   class="form-control"
                   v-model="form.phone"/>
          </div>
          <div class="col-12" v-if="!showSendOptions">
            <div class="note-ch">{{ trans('for_operative_feedback') }}.</div>
          </div>
          <div class="col-md-7 col-12 mt-2"
               v-if="needPhoneConfirm">
            <PhoneConfirm :phone="form.phone"
                          :confirmed="phoneConfirmed"
                          @confirmed="onPhoneConfirmed"/>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="label-ch d-md-block d-none" for="name-ch">{{ trans('name') }}:</label>
        <div class="row align-items-center">
          <div class="col-md-7 col-12">
            <input type="text"
                   id="name-ch"
                   :placeholder="trans('name')"
                   class="form-control"
                   v-model="form.name"/>
          </div>
        </div>
      </div>

      <div v-for="formField in additionalFormFields" :key="`formField-${formField.id}`">
        <div class="form-group">
          <label class="label-ch" :for="`additional-field-${formField.id}`">{{ transName(formField.title) }}:</label>
          <div class="row align-items-center">
            <div class="col-md-7 col-12">
              <input type="text"
                     :id="`additional-field-${formField.id}`"
                     class="form-control"
                     v-model="form.additionalFields[formField.id]"/>
            </div>
            <div class="col-12" v-if="transName(formField.note)">
              <div class="note-ch">
                {{ transName(formField.note) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group" v-if="timetable.hasPromocodes">
        <label class="label-ch" for="promo-ch">{{ trans('promocode') }}:</label>
        <div class="row align-items-center">
          <div class="col-md-7 col-12">
            <div class="position-relative">
              <input type="text"
                     id="promo-ch"
                     class="form-control"
                     v-model="form.promocode"/>
              <button @click="promocodeCheck"
                      :disabled="!form.promocode"
                      class="btn btn-themed btn-outline-secondary btn-check-promocode">
                {{ trans('check') }}
              </button>
            </div>
            <div v-if="promocodeDiscount" class="small text-primary">{{ trans('promocode_found') }}: {{ promocodeDiscount }}%</div>
            <div v-if="promocode && promocodeNotFound" class="small text-danger">{{ trans('promocode_not_found') }}</div>
          </div>
        </div>
      </div>

      <div class="form-group" v-if="canHaveComment">
        <label class="label-ch d-md-block d-none" for="comment-ch">{{ trans('comment') }}:</label>
        <div class="row align-items-center">
          <div class="col-md-7 col-12">
            <input type="text"
                   id="comment-ch"
                   :placeholder="trans('comment')"
                   class="form-control"
                   v-model="form.comment"/>
          </div>
        </div>
      </div>

      <div class="form-group" v-if="user && isOrganizerForShow">
        <label class="label-ch d-md-block d-none" for="disc-ch">{{ trans('manual_discount') }}:</label>
        <div class="row align-items-center">
          <div class="col-md-7 col-12">
            <input type="number"
                   max="99"
                   id="disc-ch"
                   :placeholder="trans('manual_discount')"
                   class="form-control"
                   v-model="form.manual_discount"/>
          </div>
        </div>
      </div>

      <!--      <div class="form-group" v-if="showSendOptions">-->
      <!--        <div class="row align-items-center g-0">-->
      <!--          <div class="col-auto">-->
      <!--            <input type="checkbox"-->
      <!--                   id="sms-send-ch"-->
      <!--                   :placeholder="trans('send_ticket_by_sms')"-->
      <!--                   class="form-check form-check-input"-->
      <!--                   v-model="sendSms"/>-->
      <!--          </div>-->
      <!--          <div class="col">-->
      <!--            <label class="d-block mb-0 ps-3" for="sms-send-ch">{{ trans('send_ticket_by_sms') }}</label>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div class="form-group" v-if="showSendOptions">-->
      <!--        <div class="row align-items-center g-0">-->
      <!--          <div class="col-auto">-->
      <!--            <input type="checkbox"-->
      <!--                   id="email-send-ch"-->
      <!--                   :placeholder="trans('send_ticket_by_email')"-->
      <!--                   class="form-check form-check-input"-->
      <!--                   v-model="sendEmail"/>-->
      <!--          </div>-->
      <!--          <div class="col">-->
      <!--            <label class="d-block mb-0 ps-3" for="email-send-ch">{{ trans('send_ticket_by_email') }}</label>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div class="form-group" v-if="showSendOptions">-->
      <!--        <div class="row align-items-center g-0">-->
      <!--          <div class="col-auto">-->
      <!--            <input type="checkbox"-->
      <!--                   id="whatsapp-send-ch"-->
      <!--                   :placeholder="trans('send_ticket_by_whatsapp')"-->
      <!--                   class="form-check form-check-input"-->
      <!--                   v-model="sendWhatsapp"/>-->
      <!--          </div>-->
      <!--          <div class="col">-->
      <!--            <label class="d-inline-block mb-0 ps-3" for="whatsapp-send-ch">-->
      <!--              {{ trans('send_ticket_by_whatsapp') }}-->
      <!--            </label>-->
      <!--            <span class="question-tooltip"-->
      <!--                  data-toggle='tooltip'-->
      <!--                  :title="trans('send_ticket_by_whatsapp_note')">?</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

    </div>

    <div v-if="order && qrCodeImage">
      <h1 class="mb-0 mt-4">{{ trans('scan_for_payment') }}:</h1>
      <div class="mt-4">
        <img :src="`data:image/png;base64,${qrCodeImage}`"
             style="width: 300px"
             alt="qr"/>
      </div>
    </div>

    <KaspiForm :order="order" ref="kform"/>

    <OTP v-if="order && confirmingEmail"
         class="mt-5"
         :email="form.email"
         @confirmed="otpConfirmed"/>

  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import EventBus from '../../../event-bus'
import OrderCounter from "./OrderCounter"
import PayMethods from "./PayMethods"
import OTP from "./OTP"
import PhoneConfirm from "./PhoneConfirm"
import KaspiForm from "./KaspiForm"
import {getGoogleCID, getMarketingId, pushToDataLayer} from "../../../helpers"
import {VueTelInput} from "vue-tel-input"
import "vue-tel-input/dist/vue-tel-input.css"
import isoCountries from "i18n-iso-countries/index.js"
import isoCountriesRu from "i18n-iso-countries/langs/ru.json"

isoCountries.registerLocale(isoCountriesRu)

const PHONE_COUNTRIES_RU = VueTelInput.props.allCountries.default().map(country => ({
  ...country,
  name: isoCountries.getName(country.iso2, 'ru') || country.name
}))

export default {
  name: "Checkout",
  components: {
    KaspiForm,
    OTP,
    PhoneConfirm,
    PayMethods,
    OrderCounter,
    VueTelInput
  },
  // head() {
  //   return {
  //     script: [
  //       {
  //         hid: 'bnpl',
  //         src: 'https://stage.bnpl.kz/widget/index_bundle.js',
  //         // src: 'https://bnpl.kz/widget/index_bundle.js',
  //         defer: true
  //       },
  //       // {
  //       //   hid: 'tiptop',
  //       //   src: 'https://widget.tiptoppay.kz/bundles/widget.js',
  //       //   // defer: true
  //       // }
  //     ]
  //   }
  // },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        comment: '',
        // pay_system: 'oxypay',
        pay_system: 'kaspi',
        promocode: '',
        manual_discount: 0,
        additionalFields: {}
        // pay_system: 'kaspi',
      },
      orderNotFound: false,
      emailConfirmed: true,
      needPhoneConfirm: false,
      confirmedPhone: null,
      promocodeNotFound: false,
      sendEmail: true,
      sendSms: true,
      sendWhatsapp: false,
      // emailConfirmed: false,
    }
  },
  computed: {
    ...mapState([
      'cart',
      'timetable',
      'order',
      'event',
      'user',
      'checkouttime',
      'confirmingEmail',
      'withoutIframe',
      'webView',
      'promocodeDiscount',
      'qrCodeImage',
      'refundable'
    ]),
    ...mapGetters([
      'hasKassirRights',
      'getCartItemsForDataLayer',
      'discountRate',
      'isOrganizerForShow',
      'totalWithFeeAndRefundable'
    ]),
    valid() {
      return this.form.name
          && this.form.phone
          && this.form.email
          && this.isValidEmail
          && this.phoneConfirmed
          && this.additionalFormFieldsAreValid
    },
    phoneConfirmed() {
      if(!this.needPhoneConfirm) return true
      if(!this.confirmedPhone || !this.form.phone) return false
      return this.onlyNumbers(this.confirmedPhone) === this.onlyNumbers(this.form.phone)
    },
    isValidEmail() {
      return String(this.form.email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
    additionalFormFieldsAreValid() {
      return this.additionalFormFields.every(field => {
        return !field.required || this.form.additionalFields[field.id]
      })
    },
    showSendOptions() {
      return this.order?.timetable?.show_id === 791
    },
    email() {
      return this.form.email
    },
    canHaveComment() {
      return ['invitation', 'invitation_hide'].includes(this.paySystem)
    },
    promocode() {
      return this.form.promocode
    },
    manual_discount() {
      return this.form.manual_discount
    },
    paySystem() {
      return this.form.pay_system
    },
    additionalFormFields() {
      return this.event?.specific_form_fields || []
    },
    newPhoneInputEnabled() {
      return true
      // return !!this.user && this.user.id === 1
    },
    phoneCountries() {
      return PHONE_COUNTRIES_RU
    },
    phoneInputOptions() {
      return {
        id: 'phone-ch',
        placeholder: this.trans('phone'),
        showDialCode: true,
        styleClasses: 'phone-tel-input-native'
      }
    },
    phoneDropdownOptions() {
      return {
        showDialCodeInList: true,
        showFlags: true,
        showSearchBox: true
      }
    }
  },
  created() {
    this.$store.commit('setStep', 3)
    if(this.hasKassirRights) {
      this.form.pay_system = 'cash'
    }
    this.loadOrder()
    EventBus.$on('fillOrder', this.orderFill)
    EventBus.$on('deleteOrderItem', this.deleteOrderItem)
    EventBus.$on('reloadOrder', this.loadOrder)
    this.populateFromUser()

  },
  beforeDestroy() {
    EventBus.$off('fillOrder', this.orderFill)
    EventBus.$off('deleteOrderItem', this.deleteOrderItem)
    EventBus.$off('reloadOrder', this.loadOrder)
  },
  methods: {
    loadOrder() {
      window.loaderIcon()
      axios.get(`/api/order/${this.$route.params.id}/${this.$route.params.hash}`).then(res => {
        let order = res.data.order
        this.$store.commit('setOrder', order)
        this.$store.commit('setTimetable', order.timetable)
        this.$store.commit('setEvent', order.timetable.show)
        this.$store.commit('setEnabledPayMethods', res?.data?.pay_methods || [])
        this.$store.commit('emptyCart')
        this.$store.commit('setRefundable', order.is_refundable ? 1 : 0)
        this.needPhoneConfirm = !!res?.data?.need_phone_confirm
        this.confirmedPhone = order.phone_confirmed || null
        order.order_items.forEach(item => {
          if(item.is_promo) return // free promo ticket comes together with its main pricegroup position
          const sign = "+"
          let seatId = item.vendor_seat_id ? String(item.vendor_seat_id) : item.seat_id
          if(['showmarket'].includes(order.vendor)) seatId = item.seat_id // for all the vendors that do not have own scheme
          const ticket = {
            order_item_id:  item.id,
            ticket_id:      item.vendor_ticket_id || item.vendor_seat_id || item.ticket_id,
            seat_id:        seatId,
            section_id:     item.section_id,
            row:            item.row,
            seat:           item.seat,
            price:          item.original_price,
            pricegroup_id:  item.pricegroup_id,
            pricegroup_amount_of_tickets: item.pricegroup?.amount_of_tickets || 1,
            pricegroup_name:item.pricegroup ? item.pricegroup.title : {},
            section_name:   item.section ? item.section.title : {},
            min_tickets:    item.section && item.section.min_tickets ? item.section.min_tickets : 1,
          }
          this.$store.commit('updateCart', { sign, ticket, ignoreGTag: true, ignoreLimit: true })
        })
        this.form.name = order.name
        this.form.email = order.email
        this.form.phone = order.phone || ''
        this.form.comment = order.comment
        if(!order.name) {
          this.populateFromUser()
        }
        // if(!this.form.phone || this.form.phone == '-') this.form.phone = '+7'
        if(window && window.parent) {
          window.parent.postMessage(JSON.stringify({
            action: 'setOrder',
            data:   order
          }), '*');
        }
      }).catch((e) => {
        this.orderNotFound = true
      })
    },
    deleteOrderItem(id) {
      window.loaderIcon()
      axios.delete(`/api/order/${this.order.id}/${this.order.hash}/item/${id}`).then(() => {
        this.loadOrder()
      })
    },
    populateFromUser() {
      if(this.user) {
        this.form.name  = this.user.name
        this.form.email = this.user.email
        this.form.phone = this.user.phone || ''
      }
    },
    restrictPhoneInput() {
      this.form.phone = this.form.phone.replace(/[^0-9+]/g, '')
      if(this.form.phone.length === 1) this.form.phone = '+'
      if(this.form.phone.length === 2) this.form.phone = '+7'
    },
    onPhoneDropdownOpen() {
      this.$nextTick(() => {
        const searchBox = this.$refs.phoneTelInput?.$el.querySelector('.vti__search_box')
        if(!searchBox) return
        searchBox.placeholder = 'Поиск по названию страны или коду'
        searchBox.addEventListener('mousedown', e => e.stopPropagation())
        searchBox.addEventListener('click', e => e.stopPropagation())
      })
    },
    async orderFill() {
      if(!this.phoneConfirmed) {
        this.$store.commit('setLoading', false)
        window.noty(this.trans('confirm_your_phone'), 'error')
        return
      }
      if(!this.emailConfirmed) {
        this.$store.commit('setConfirmingEmail', true)
        return
      }
      window.loaderIcon()
      if(!this.canHaveComment) this.form.comment = ''
      try {
        const res = await axios.post(`/api/order/${this.order.id}/${this.order.hash}/fill`, {
          ...this.form,
          timetable_id: this.timetable.id,
          is_refundable: this.refundable === null ? 1 : this.refundable,
          sendEmail: this.sendEmail,
          sendSms: this.sendSms,
          sendWhatsapp: this.sendWhatsapp,
          mobile: this.withoutIframe,
          marketingData: {
            fbp: getMarketingId('fbp'),
            fbc: getMarketingId('fbc'),
            ga_client_id: getMarketingId('gaClientId') || getGoogleCID(),
            ga_session_id: getMarketingId('gaSessionId'),
            gclid: getMarketingId('gclid'),
            utm_source: getMarketingId('utmSource'),
            utm_medium: getMarketingId('utmMedium'),
            utm_campaign: getMarketingId('utmCampaign'),
            utm_content: getMarketingId('utmContent'),
            utm_term: getMarketingId('utmTerm'),
          },
        })
        this.$store.commit('setLoading', false)
        pushToDataLayer({
          event: 'begin_checkout',
          login: !!this.user,
          value: Number(this.totalWithFeeAndRefundable),
          payment_type: this.form.pay_system,
          ecommerce: {
            event: 'begin_checkout',
            currency: 'KZT',
            items: this.getCartItemsForDataLayer
          }
        }, this.user)
        let d = res.data
        if(d && d.success && ['kaspi'].includes(this.form.pay_system) && this.withoutIframe && !this.webView) {
          this.$refs.kform.submit()
          return
        }
        if(d?.success && ['kaspi'].includes(this.form.pay_system) && !this.withoutIframe && d?.qr && d?.qr?.qrCodeImage) {
          this.$store.commit('setQRCodeImage', d.qr.qrCodeImage)
          this.preventModalClosingFromCancellingOrder()
          return
        }
        if(d?.success && d?.tiptop) {
          const tipTopWidget = new window.tiptop.Widget()
          const tipTopParams = JSON.parse(JSON.stringify(d.tiptop))
          try {
            const widgetResult = await tipTopWidget.start(tipTopParams)
            const transactionId = widgetResult?.data?.transactionId
            if (
                widgetResult?.type === 'payment' &&
                widgetResult?.status === 'success' &&
                transactionId
            ) {
              await this.bnplFinished()
            }
          } catch (e) {
            console.log('error', e)
          }
          return
        }
        if(d?.success && d?.bnpl) {
          const bnpl = new window.BnplKzApi.CPO({
            rootId: 'bnplKz-root', // optional default 'bnplKz-root'
            callbacks: {
              onLoad: () => console.log('onLoad'), //optional
              onError: ({ code, message }) => console.log('onError', code, message), // optional, code = "clientError" || "apiError"
              onClosed: () => console.log('onClosed'), //optional
              onEnd: this.bnplFinished,
              onRestart: (redirectLink) => console.log(redirectLink),
              onDeclined: () => console.log('onDeclined')
            }
          })
          bnpl.render({
            redirectLink: d.bnpl
          })
          return
        }
        if(d?.success && d?.redirect) {
          if(window && window.parent) {
            if(['card'].includes(this.form.pay_system)) {
              window.parent.postMessage(JSON.stringify({
                action: 'addClass',
                data: 'pt-5'
              }), '*');
            }
            if(['invitation', 'invitation_hide', 'cash', 'kaspi', 'smartcore'].includes(this.form.pay_system)) {
              this.preventModalClosingFromCancellingOrder()
            }
          }
          window.location = d.redirect
          return
        }
        if(d && d.error) {
          window.noty(d.error,'error')
          return
        }
        window.noty('Что-то пошло не так','error')
      } catch (e) {
        console.log(e)
      } finally {
        this.$store.commit('setLoading', false)
      }
    },
    onlyNumbers(str) {
      return String(str || '').replace(/[^0-9]/g, '')
    },
    onPhoneConfirmed(phone) {
      this.confirmedPhone = phone || this.form.phone
    },
    otpConfirmed() {
      this.emailConfirmed = true
      this.$store.commit('setConfirmingEmail', false)
      this.orderFill()
    },
    promocodeCheck() {
      window.loaderIcon()
      axios.post('/api/promocode', { timetable_id: this.timetable.id, promocode: this.form.promocode }).then(res => {
        this.$store.commit('setPromocodeDiscount', res.data)
        if(res.data === 0) {
          this.promocodeNotFound = true
        }
      }).catch((e) => {
        if(e.response.data) {
          window.noty(e.response.data,'error')
        }
        console.log('error', e.response.data)
      })
    },
    async bnplFinished() {
      this.preventModalClosingFromCancellingOrder()
      const url = `/payment/${this.order.id}/${this.order.hash}/result`
      location.href = url
      await this.router.push(url)
      this.$store.commit('emptyCart')
    },
    preventModalClosingFromCancellingOrder() {
      window.parent.postMessage(JSON.stringify({
        action: 'setOrder',
        data: null
      }), '*');
    }
  },
  watch: {
    valid(val) {
      this.$store.commit('setCheckoutFormValid', val)
    },
    email(val) {
      this.emailConfirmed = true
      // this.emailConfirmed = this.user && this.user.email == val
    },
    promocode() {
      this.$store.commit('setPromocodeDiscount', 0)
      this.promocodeNotFound = false
    },
    manual_discount(val) {
      if(val > 99) {
        this.form.manual_discount = 99
        val = 99
      }
      this.$store.commit('setManualDiscount', val)
    },
    sendSms(val) {
      if(!val) {
        this.sendEmail = true
      }
    },
    sendEmail(val) {
      if(!val) {
        this.sendSms = true
      }
    },
    paySystem(val) {
      if(val) {
        pushToDataLayer({
          event: 'add_payment_info',
          login: !!this.user,
          value: val,
          ecommerce: {
            event: 'add_payment_info',
            currency: 'KZT',
            payment_type: val,
            items: this.getCartItemsForDataLayer
          }
        }, this.user)
      }
    }
  },
  metaInfo() {
    return {
      title: this.trans('order_checkout'),
      meta: []
    }
  },
  mounted() {
    pushToDataLayer({
      event: 'view_cart',
      login: !!this.user,
      ecommerce: {
        event: 'view_cart',
        currency: 'KZT',
        items: this.getCartItemsForDataLayer
      }
    }, this.user)
  }
}
</script>

<style scoped>
.checkout-form {
  padding-bottom: 160px;
}
.phone-tel-input {
  padding: 0 !important;
  border: 1px solid #E5E7EA;
  border-radius: 8px;
  background: #FFFFFF;
}
.phone-tel-input:focus-within {
  border-color: #4bb0fe;
  box-shadow: none;
}
.phone-tel-input ::v-deep .vti__search_box {
  margin: 0;
  width: 100%;
  border: none;
  background: #f9f9f9;
  border-bottom: 1px solid #E5E7EA;
}
.phone-tel-input ::v-deep .vti__dropdown {
  padding: 0 8px;
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
}
.phone-tel-input ::v-deep .vti__dropdown-list {
  z-index: 5;
}
.phone-tel-input ::v-deep .phone-tel-input-native {
  padding: 10px 14px 10px 4px;
  font-size: inherit;
  color: inherit;
  background: transparent;
}
.btn-check-promocode {
  background: transparent;
  border: 1px solid #4bb0fe;
  color: #4bb0fe;
  height: 40px;
  padding: 0 20px;
  position: absolute;
  right: 3px;
  top: 3px;
  z-index: 4;
}

@media(max-width: 768px) {
  .btn-check-promocode {
    padding: 0 15px;
    height: 37px;
  }
}
</style>
